export const EX_RULE_SYNCING_STATUS = {
    WAITING: 'waiting',
    SYNCING: 'syncing',
    FINISHED: 'finished',
};

export const EX_JOB_STATUS = {
    WAITING: 'waiting',
    RUNNING: 'running',
    FINISHED: 'finished',
    FAILED: 'failed',
    CANCEL: 'cancel',
};

export const EX_DATATYPE = {
    BOOLEAN: 'boolean',
    TIMESTAMP: 'timestamp',
    STRING: 'string',
    NUMERIC: 'numeric'
};

export const EXT_OBJECT_TYPE = {
    EXT_COMPANY: 'ext-company',
    EXT_GENERIC: 'ext-generic',
    EXT_PERSON: 'ext-person',
    EXT_GENERIC_REVENUE: 'ext-generic-revenue',
};

export const WRITE_RULE_SECTION = {
    [EX_DATATYPE.NUMERIC]: 'Numeric',
    [EX_DATATYPE.TIMESTAMP]: 'Datetime',
    [EX_DATATYPE.STRING]: 'Textarea',
    [EX_DATATYPE.BOOLEAN]: 'Checkbox',
    email: 'Textarea',
    domain: 'Textarea',
    default: 'default',
};

export const TYPE_REVENUE_RULE = [
    { value: 'trx', label: 'Transaction (one-time purchase)' },
];

export const BOOLEAN_OPTIONS = [
    { value: 'true', label: 'True' },
    { value: 'false', label: 'False' }
];

export const CONDITION_OPERATOR_REVENUE_RULE = [
    { value: 'ct', label: 'Contains' },
    { value: 'nct', label: 'Not Contains' },
    { value: 'bgw', label: 'Begins with' },
    { value: 'exac', label: 'Exactly Matches' },
    { value: 'gt', label: 'Is Greater than' },
    { value: 'lt', label: 'Is Less Than' },
    { value: 'eq', label: 'Equals' },
    { value: 'neq', label: 'Not Equal' },
    { value: 'af', label: 'Is After' },
    { value: 'bf', label: 'Is Before' },
    { value: 'on', label: 'Is On' },
];

export const DEFAULT_REVENUE_RULE_DESCRIPTION = {
    'Amount': 'Select the field that represents the revenue amount. If you need to calculate a revenue amount, select the field you calculate against and then complete the formula.',
    'Quantity': 'Select the field that represents the quantity or enter a harcoded value.',
    'Currency': 'Select the field that represents the currency or enter a harcoded value.',
    'Probability': 'Select the field that represents the probability this will revenue will be contracted. If you choose to manually enter a probability to apply to all imported data on this revenue row, then use a value between 0 and 1, where 1 = 100% (i.e. 0.75 = 75%).',
};
